export default [
  0,
  '0.25rem',
  '0.5rem',
  '1rem',
  '2rem',
  '2rem',
  '8rem',
  '16rem',
  '32rem'
]
